var map = {
	"./age_green.svg": [
		66833,
		6833
	],
	"./age_red.svg": [
		66917,
		6917
	],
	"./age_yellow.svg": [
		67000,
		7000
	],
	"./duration_green.svg": [
		26032,
		6032
	],
	"./duration_orange.svg": [
		59221,
		9221
	],
	"./duration_red.svg": [
		4816,
		4816
	],
	"./duration_yellow.svg": [
		30327,
		327
	],
	"./logo.svg": [
		49089
	],
	"./ltv_green.svg": [
		86430,
		6430
	],
	"./ltv_orange.svg": [
		84035,
		4035
	],
	"./ltv_red.svg": [
		38046,
		8046
	],
	"./ltv_yellow.svg": [
		84549,
		4549
	],
	"./nhg_no.svg": [
		35253,
		5253
	],
	"./nhg_unknown.svg": [
		68894,
		8894
	],
	"./nhg_yes.svg": [
		58526,
		6145
	],
	"./pension_green.svg": [
		79042,
		9042
	],
	"./pension_orange.svg": [
		95343,
		5343
	],
	"./pension_red.svg": [
		98274,
		8274
	],
	"./pension_yellow.svg": [
		24713,
		4713
	],
	"./result_negative.svg": [
		52043
	],
	"./result_positive.svg": [
		31039
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 43332;
module.exports = webpackAsyncContext;